import { Component, OnInit, Inject, AfterViewChecked, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { DatacontextService } from 'src/app/data/datacontext.service';
import { AnalyticsChartService } from '../services/analytics/analytics-chart.service';
import moment from 'moment';
import { CommonNotificationService } from 'src/app/shared/services/common-notification/common-notification.service';
import { EditorCommonService } from '../editor/editor-common.service';
import { UserInfoService } from 'src/app/shared/services/user-info/user-info.service';
import { AppSelectorService } from 'src/app/shared/services/app-selector/app-selector.service';
import { DocsLink } from 'src/app/shared/constants/docs-link';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { FeatureListJsonService } from 'src/app/shared/services/config-manager/feature-list/feature-list-json.service';
import { NodeIndexService } from '../journey-builder/services/node-index.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { cloneDeep } from 'lodash';
import { ResultService } from '../result/result.service';
import { SettingsService } from 'src/app/data/repositories/settings/settings.service';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Component({
  selector: 'app-prompts-analytics-dialog',
  templateUrl: './prompts-analytics-dialog.component.html',
  styleUrls: ['./prompts-analytics-dialog.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class PromptsAnalyticsDialogComponent implements OnInit, AfterViewChecked, OnDestroy {
  chartLoading;
  chartType = 'line';
  step = 'day';
  duration = '3D';
  querySubscriber;
  reportTimeOptions = this.analyticsChartService.getReportTimeOptions();
  selectedTimeOption = this.reportTimeOptions[0];
  sendAnalyticsEvent: Boolean = false;
  sendAnalyticsToggleStateChanged: Boolean = false;
  journeyData: any;
  showNudgeId: Boolean = false;
  node: any;
  chartData;
  pageLoading;
  panelOpenState = false;
  templateToNameMap;
  labelsMap;
  dilDataRequestedPrompts = {};
  dilDownloadDataBtnDebounce = 10 * 60 * 1000;
  templateNameToResultCategoryMap;
  analyticsType: any = 'View';
  // lineChart
  public lineChartData: Array<any> = [];
  public lineChartLabels: Array<any> = [];
  public lineChartOptions: any = this.analyticsChartService.getLineChartOptions();
  public lineChartColors: Array<any> = this.analyticsChartService.getLineChartColors();
  public docLinks = DocsLink.sdkIntegrationDocLinks;
  private confirmationDialogRef: MatDialogRef<ConfirmationDialogComponent>;
  // lineChart end
  analyticsData = [];
  expandedElement;
  public feedbackNudgeMap: any = {
    multi_choice_questionnaire: 'multi_choice_questionnaire',
    net_promoter_score: 'net_promoter_score',
    user_feedback: 'user_feedback',
    rating_n_review: 'rating_n_review',
    rating_with_user_feedback: 'rating_with_user_feedback',
    nps_with_user_feedback: 'nps_with_user_feedback'
  }
  expStackMap: any;
  feedbackReportRequested: any = {};
  timeoutRef: any;
  public selectedEvent: any;
  public nudgesAndWrapperNodes: any;
  public appDetails: any;
  private resultQueryData: any = new Subject<any>();
  private resultAttributeData: any = new Subject<any>();
  private attrQuerySubscriber: any;
  private attrTimeoutRef: any;
  private eventTypeMap: any = {
    generic: 'Total Events',
    conversion: 'Unique Users',
    sum: 'Sum of Property'
  }

  constructor(
    private dialogRef: MatDialogRef<PromptsAnalyticsDialogComponent>,
    private cdRef: ChangeDetectorRef,
    private analyticsChartService: AnalyticsChartService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonNotificationService: CommonNotificationService,
    private datacontextService: DatacontextService,
    private editorCommonService: EditorCommonService,
    private nodeIndexService: NodeIndexService,
    private userInfoService: UserInfoService,
    public appSelectorService: AppSelectorService,
    private featureListJsonService: FeatureListJsonService,
    private dialog: MatDialog,
    private resultService: ResultService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    if (this.data.analyticsData.events.length) {
      this.selectedEvent = this.data.analyticsData.events[0];
    }
    this.lineChartOptions.legend['display'] = false;
    this.templateToNameMap = this.editorCommonService.getTemplateToNameMap();
    this.templateNameToResultCategoryMap = this.editorCommonService.getTemplateNameToResultCategoryMap();
    this.labelsMap = this.editorCommonService.getLabelsMap();
    this.fetchAllExpStackResult();
    this.featureListJsonService.shouldEnableTheFeature('interaction_maps.results.show_branch_ids', true, flag => this.showNudgeId = flag);
  }

  ngOnDestroy() {
    this.clearTimerAndSubs();
  }

  clearTimerAndSubs() {
    this.clearSubscription('querySubscriber');
    this.clearSubscription('attrQuerySubscriber');
    this.clearTimeoutVal('timeoutRef');
    this.clearTimeoutVal('attrTimeoutRef');
  }

  fetchAllExpStackResult() {
    const resultObj = {
      nudges: [],
      wrapperNodes: []
    }
    this.nudgesAndWrapperNodes = this.nodeIndexService.getExpStack(this.data.dtree[0], this.data.dtree[0], resultObj);
    const expStack = this.nudgesAndWrapperNodes.nudges;
    let accordIndex = 0;
    let isNudgeClicked = false;
    const time = this.analyticsChartService.getStartAndEndTime(this.step, this.duration);
    this.analyticsData = [];
    this.expStackMap = expStack.reduce((acc, exp) => {
      acc[exp.lidx] = exp;
      return acc;
    }, {});
    expStack.forEach((exp, index) => {
      const obj = {
        template: exp.actions[0].display_prompt.template,
        title: exp.title,
        lidx: exp.lidx
      };
      this.analyticsData.push(obj);
      if (exp.lidx === this.data.analyticsData.nodeIdx) {
        accordIndex = index;
        isNudgeClicked = true;
      }
    });
    if (isNudgeClicked) {
      this.clickRow(this.analyticsData[accordIndex]);
    }
  }

  getResultForNode(nodePath, time) {
    return new Promise((resolve, reject) => {
      this.datacontextService.analytics.getPromptsAnalytics(
        this.data.analyticsData.journey_id,
        nodePath,
        this.step,
        time.start.format('DD/MM/YYYY'),
        time.end.format('DD/MM/YYYY'),
        null
      ).subscribe((data: any) => {
        if (data.is_error) {
          reject();
          return;
        }
        resolve(data.api_response.data);
      });
    });
  }

  queryPromptsAnalytics = (lidx) => {
    if (lidx) {
      this.chartLoading = true;
    } else {
      this.pageLoading = true;
    }
    this.chartData = [];
    const time = this.analyticsChartService.getStartAndEndTime(this.step, this.duration);
    let lidxArray = null;
    if (lidx) {
      lidxArray = [lidx];
    }
    const payload = {
      journey_id: this.data.analyticsData.journey_id,
      node_path: this.data.analyticsData.node_path,
      step: this.step,
      time,
      lidxArray,
      lidx
    }
    this.handleQueryRequest(payload);
  }

  clearTimeoutVal(prop) {
    if (this[prop]) {
      clearTimeout(this[prop]);
      this[prop] = null;
    }
  }

  handleQueryRequest = (payload) => {
    this.clearTimeoutVal('timeoutRef');
    this.clearSubscription('querySubscriber');
    this.querySubscriber = this.datacontextService.analytics.getPromptsAnalytics(
      payload.journey_id,
      payload.node_path,
      payload.step,
      payload.time.start.format('DD/MM/YYYY'),
      payload.time.end.format('DD/MM/YYYY'),
      payload.lidxArray
    ).subscribe((data: any) => {
      if (data.is_error) {
        if (data.error_type === 'ERROR_RETRY_AFTER_10') {
          this.clearTimeoutVal('timeoutRef');
          this.timeoutRef = setTimeout(this.handleQueryRequest, 10 * 1000, payload);
        }
        return;
      }
      if (payload.lidx) {
        this.resultQueryData.next(data.api_response.data[0]);
        this.resultQueryData.complete();
      } else {
        this.analyticsData = data.api_response.data;
        this.pageLoading = false;
      }
    }, (err) => {
    });
  }

  getTooltipMessage(promptObj) {
    if (this.dilDataRequestedPrompts[promptObj.lidx]) {
      return 'Request for download is already initiated. Try again in ten minutes';
    } else if (this.isDilDownloadBtnDisabled(promptObj)) {
      switch (promptObj.template) {
        case 'newsletter_subscription':
        case 'beta_test_signups':
          return 'Subscription data has not been received yet';
        default:
          return 'User Feedback has not been received yet';
      }
    }
  }


  isDilDownloadBtnDisabled(promptObj) {
    if (this.dilDataRequestedPrompts[promptObj.lidx]) {
      return this.dilDataRequestedPrompts[promptObj.lidx];
    }
    switch (promptObj.template) {
      case 'nps_with_user_feedback':
        if (this.chartData['tdata'].detr_ccount + this.chartData['tdata'].pass_ccount + this.chartData['tdata'].prom_ccount > 0) {
          return false;
        }
        return true;
      case 'rating_with_user_feedback':
        if (this.chartData['tdata'].cumul_average_rating > 0) {
          return false;
        }
        return true;
      default:
        return !this.hasKeys(this.chartData['tdata']['last5_reviews']);
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges(); // "expression has changed after it was checked" - exception
  }

  onRequestDilData(promptObj) {
    if (this.isDilDownloadBtnDisabled(promptObj)) {
      return;
    }
    this.userInfoService.getUserData()
      .then(data => {
        // Disable button
        if (this.dilDataRequestedPrompts[promptObj.lidx]) {
          return false;
        }
        this.dilDataRequestedPrompts[promptObj.lidx] = true;
        setTimeout(() => {
          this.dilDataRequestedPrompts[promptObj.lidx] = false;
        }, this.dilDownloadDataBtnDebounce);
        // call service
        this.datacontextService.analytics.dilDataSendmail({
          app_id: this.appSelectorService.getSelectedApp().id,
          email_ids: [data.email],
          journey_hash: this.data.analyticsData.journey_hash,
          prompt: promptObj,
          prompt_template: this.editorCommonService.templateToNameMap[promptObj.template],
          duration: this.duration
        }
        ).subscribe((result: any) => {
          if (!result || result.is_error) {
            this.commonNotificationService.showSnackBar('Failed to initiate download. Please try again ', 'error');
          } else {
            this.commonNotificationService.showSnackBar('Your request for download has been received. \
          You will receive an email once the download is processed', 'success');
          }
        });
      });
  }

  activate(promptElement?) {
    this.chartLoading = true;
    if (promptElement) {
      this.chartData = promptElement;
      this.chartData['opened'] = true;
    } else {
      this.chartData = this.analyticsData[0];
    }
    this.chartData['sendAnalyticsEvent'] = false;
    this.handleNudgePropUpdate(this.data.dtree[0], this.chartData);
    const time = this.analyticsChartService.getStartAndEndTime(this.step, this.duration);
    const xAxis = this.analyticsChartService.generateX(time.start, time.end, this.step);
    this.lineChartLabels.length = 0;
    for (let i = 0; i < xAxis.length; i++) {
      this.lineChartLabels.push(xAxis[i]);
    }
    this.chartType = 'line';
    this.lineChartOptions = this.analyticsChartService.getLineChartOptions();
    this.lineChartOptions.legend['display'] = false;
    this.populateGraphForCategories();
    setTimeout(() => {
      this.chartLoading = false;
    }, 1000);
  }

  populateGraphForCategories() {
    this.analyticsType = this.templateNameToResultCategoryMap[this.chartData['template']];
    this.lineChartData = [];
    switch (this.analyticsType) {
      case 'NPS':
        this.lineChartOptions['scales']['yAxes'][0]['scaleLabel']['labelString'] = 'NUMBER OF USERS';
        this.graphIterator(true, ['prom_count', 'pass_count', 'detr_count'], null, 'NPS');
        return;
      // check - same as NPS
      case 'NPS-with-user-feedback':
        this.lineChartOptions['scales']['yAxes'][0]['scaleLabel']['labelString'] = 'NUMBER OF USERS';
        this.graphIterator(true, ['prom_count', 'pass_count', 'detr_count'], null, 'NPS');
        return;
      case 'Button':
        this.lineChartOptions['scales']['yAxes'][0]['scaleLabel']['labelString'] = 'COUNT'; // previously 'BUTTON CLICKS'
        this.graphIterator(true, this.getButtonCountArray(), null, 'Button');
        // add views
        // this.graphIterator(false, null, 'count', 'Count'); // for views
        return;
      case 'Rating':
        this.lineChartOptions['scales']['yAxes'][0]['scaleLabel']['labelString'] = 'AVERAGE RATING';
        this.graphIterator(false, null, 'average_rating_count', 'Rating');
        return;
      // check - same as Rating
      case 'Rating-with-user-feedback':
        this.lineChartOptions['scales']['yAxes'][0]['scaleLabel']['labelString'] = 'AVERAGE RATING';
        this.graphIterator(false, null, 'average_rating_count', 'Rating');
        return;
      case 'Feedback':
        this.lineChartOptions['scales']['yAxes'][0]['scaleLabel']['labelString'] = 'COUNT'; // previously 'NUMBER OF FEEDBACKS'
        this.graphIterator(false, null, 'review_count', 'Feedback');
        // add views
        // this.graphIterator(false, null, 'count', 'Count'); // for views
        return;
      case 'Multi':
        this.multiChoiceGraph();
        return;
      default:
        // VIEWS
        this.lineChartOptions['scales']['yAxes'][0]['scaleLabel']['labelString'] = 'NUMBER OF VIEWS';
        this.graphIterator(false, null, 'count', 'Count');
        return;
    }
  }

  getButtonCountArray() {
    const countKeys = [];
    if (this.hasButton('b1_ccount')) {
      countKeys.push('b1_count');
    }
    if (this.hasButton('b2_ccount')) {
      countKeys.push('b2_count');
    }
    return countKeys;
  }

  multiChoiceGraph() {
    this.chartType = 'bar';
    this.lineChartOptions = this.analyticsChartService.getBarChartOptions();
    this.lineChartLabels.length = 0;
    const barChartKeys = Object.keys(this.chartData['tdata']['count']);
    for (let i = 0; i < barChartKeys.length; i++) {
      this.lineChartLabels.push(barChartKeys[i]);
    }
    this.lineChartData.push({
      data: this.populateMultiChoiceGraphData(barChartKeys)
    });
  }

  populateMultiChoiceGraphData(barChartKeys) {
    const yValue = barChartKeys.map(x => {
      return this.chartData['tdata']['count'][x];
    });
    return yValue;
  }

  graphIterator(isMultiple, key, countKey, type) {
    if (!isMultiple) {
      this.lineChartData.push({
        data: this.populateData(this.chartData['tdata'][countKey], this.chartData['tdata']['t'], this.lineChartLabels),
        label: this.getLabel(type), // check
        fill: false,
        borderWidth: 1.5
      });
    } else {
      for (let i = 0; i < key.length; i++) {
        this.lineChartData.push({
          data: this.populateData(this.chartData['tdata'][key[i]], this.chartData['tdata']['t'], this.lineChartLabels),
          label: this.getLabel(type, key[i], this.chartData['lidx']), // check
          fill: false,
          borderWidth: 1.5
        });
      }
      if (type === 'Button' /*|| type === 'Feedback'*/) {
        // feedback now treated as button
        this.lineChartData.push({
          // total views
          data: this.populateData(this.chartData['tdata']['count'], this.chartData['tdata']['t'], this.lineChartLabels),
          label: this.getLabel('Count'), // check
          fill: false,
          borderWidth: 1.5
        });
        if (this.chartData['template'] === 'newsletter_subscription' || this.chartData['template'] === 'beta_test_signups' || this.chartData['template'] === 'user_feedback') {
          this.lineChartData.push({
            // total submissions
            data: this.populateData(this.chartData['tdata']['b2_count'], this.chartData['tdata']['t'], this.lineChartLabels),
            label: this.getLabel('Submissions'), // check
            fill: false,
            borderWidth: 1.5
          });

        }
      }
    }
  }

  getLabel(type, key?, lidx?) {
    switch (type) {
      case 'NPS':
        return this.getNPSLabel(key);
      case 'NPS-with-user-feedback':
        return this.getNPSLabel(key);
      case 'Button':
        return this.getButtonLabel(key, lidx);
      case 'Rating':
        return 'Average Rating';
      case 'Rating-with-user-feedback':
        return 'Average Rating';
      case 'Feedback':
        return 'Review Count';
      case 'Submissions':
        return 'Submission Count';
      default:
        return 'Views';
    }
  }

  getNPSLabel(keyName) {
    switch (keyName) {
      case 'prom_count':
        return 'Promoters Count';
      case 'pass_count':
        return 'Passive Count';
      case 'detr_count':
        return 'Detractors Count';
      default:
        return 'Count';
    }
  }

  getButtonLabel(key, lidx) {
    const keyLabel = (key === 'b1_count') ? 'btn1' : 'btn2';
    if (key && lidx && this.expStackMap.hasOwnProperty(lidx)) {
      const changesObj = this.expStackMap[lidx]['actions'][0]['display_prompt']['changes'];
      if (changesObj[keyLabel]) {
        return ('Button - ' + this.editorCommonService.parseVisualizerLabelTxt(
          changesObj[keyLabel]['props'], 'name')
        );
      }
    }
    return 'Count';
  }

  populateData(dataArray, t, timeLine) {
    const yValue = timeLine.map(function (x) {
      return 0;
    });
    if (dataArray && t) {
      t.forEach(function (dx, idx) {
        if (timeLine.indexOf(dx) >= 0) {
          yValue[timeLine.indexOf(dx)] = dataArray[idx];
        }
      });
    }
    return yValue;
  }

  onTimeOptionChange(lidx) {
    this.step = this.selectedTimeOption.step;
    this.duration = this.selectedTimeOption.duration;
    this.fetchAppDetailsAndQueryResult(lidx);
  }

  resetTimeOptionsAndUpdateOpenedFlag() {
    this.selectedTimeOption = this.reportTimeOptions[3];
    this.step = 'day';
    this.duration = '3M';
    if (this.chartData && this.chartData.hasOwnProperty('opened')) {
      this.chartData['opened'] = false;
    }
  }

  resetTimeOptions(data) {
    data.selectedTimeOption = this.reportTimeOptions[0];
    this.selectedTimeOption = this.reportTimeOptions[0];
    this.step = this.selectedTimeOption.step;
    this.duration = this.selectedTimeOption.duration;;
  }

  hasButton(str) {
    if (this.chartData && this.chartData.tdata) {
      return this.chartData.tdata.hasOwnProperty(str);
    }
    return false;
  }

  calculatePercentage(num, sum): any {
    if (num && sum) {
      const percent = this.toFixed((num * 100) / sum, 2);
      return percent;
    }
    return 0;
  }

  toFixed(num, fixed) {
    // const re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    // return Number(num.toString().match(re)[0]);
    return Number.parseFloat(num.toFixed(fixed));
  }

  sumOfNps(tdata) {
    return tdata['prom_ccount'] + tdata['pass_ccount'] + tdata['detr_ccount'];
  }

  sumOfStarRating(tdata) {
    return tdata['star1_per'] + tdata['star2_per'] + tdata['star3_per'] + tdata['star4_per'] + tdata['star5_per'];
  }

  getKeys(obj) {
    if (obj) {
      return Object.keys(obj);
    }
    return [];
  }

  sumOfMultiChoice(tdata) {
    const multiChoiceKeys = this.getKeys(tdata['count']);
    let sum = 0;
    for (let i = 0; i < multiChoiceKeys.length; i++) {
      sum += tdata['count'][multiChoiceKeys[i]];
    }
    return sum;
  }

  hasKeys(obj) {
    if (obj && typeof (obj) === 'object') {
      if (Object.keys(obj).length > 0) {
        return true;
      }
    }
    return false;
  }

  calculateNpsScore(tdata) {
    const promPercentage = this.calculatePercentage(tdata['prom_ccount'], this.sumOfNps(tdata));
    const detrPercentage = this.calculatePercentage(tdata['detr_ccount'], this.sumOfNps(tdata));
    return this.toFixed(promPercentage - detrPercentage, 2);
  }

  getStarCountArray(tdata) {
    const sDataLen = Object.keys(tdata.sdata).length;
    const maxNum = sDataLen ? sDataLen : tdata.star_count;
    let starArr = [];
    for (let i = maxNum; i >= 1; i--) {
      let obj = {};
      obj['text'] = 'star' + i + '_per';
      obj['disabled'] = i > tdata.star_count ? true : false; // special case. In case star rating is changed later mark particular rating as disabled
      starArr.push(obj);
    }
    return starArr;
  }

  getSubmissionCount(type) {
    let submissionCount: string;
    switch (type) {
      case 'Button': // accounts for feedback, newsletter, beta-signups
      case 'Multi':
      case 'Rating':
      case 'Rating-with-user-feedback':
      case 'NPS':
      case 'NPS-with-user-feedback':
        submissionCount = 'submission_count';
        break;
    }
    return submissionCount;
  }

  showTotalViewsSubmissions(nudge) {
    switch (nudge) {
      case 'newsletter_subscription':
      case 'net_promoter_score':
      case 'rating_n_review':
      case 'multi_choice_questionnaire':
      case 'user_feedback':
      case 'rating_with_user_feedback':
      case 'nps_with_user_feedback':
      case 'beta_test_signups':
        return true;
      default:
        return false;
    }
  }

  /**
   * we would hide total_submission field too if the key is not present in the chartData['tData']
   */
  isKeyPresentInChartData(type) {
    if (!(this.chartData && this.chartData.hasOwnProperty('tdata'))) {
      return false;
    }
    const key = this.getSubmissionCount(type);
    if (!key) {
      return false;
    }
    if (!this.chartData['tdata'].hasOwnProperty(key)) {
      return false;
    }
    return true;
  }

  openDocs() {
    window.open('https://docs.hansel.io/docs/results-for-templates#section-net-promoter-score', '_blank');
  }

  handleNudgePropUpdate(node, chartData, toggleState?) {
    const body = this.editorCommonService.getNodeBody(node);
    body.exp_stack.forEach(nudge => {
      if (nudge.actions[0].display_prompt && nudge.actions[0].display_prompt.hasOwnProperty('send_nudge_events') && nudge.lidx === chartData.lidx) {
        if (typeof toggleState === 'undefined') {
          chartData.sendAnalyticsEvent = nudge.actions[0].display_prompt.send_nudge_events;
        }
        if (typeof toggleState === 'boolean') {
          nudge.actions[0].display_prompt.send_nudge_events = toggleState;
        }
      } else if (nudge.actions[0].display_prompt && !nudge.actions[0].display_prompt.hasOwnProperty('send_nudge_events')) {
        nudge.actions[0].display_prompt['send_nudge_events'] = false;
      }
    });
    switch (this.editorCommonService.getNodeType(node)) {
      case 'ab_exp_node':
        for (const statement of body.default_statements) {
          this.handleNudgePropUpdate(statement, chartData, toggleState);
        }
        for (const split of body.split) {
          for (const statement of split.statements) {
            this.handleNudgePropUpdate(statement, chartData, toggleState);
          }
        }
        break;
      case 'rollout_node':
        for (const statement of body.default_statements) {
          this.handleNudgePropUpdate(statement, chartData, toggleState);
        }
        for (const statement of body.statements) {
          this.handleNudgePropUpdate(statement, chartData, toggleState);
        }
        break;
      case 'decision_node':
        for (const segment of body.segments) {
          for (const statement of segment.statements) {
            this.handleNudgePropUpdate(statement, chartData, toggleState);
          }
        }
        break;
      case 'action_node':
        for (const statement of body.statements) {
          this.handleNudgePropUpdate(statement, chartData, toggleState);
        }
        break;
    }
  }

  toggleAnalyticsEvent(state, chartData) {
    this.chartLoading = true;
    this.sendAnalyticsToggleStateChanged = true;
    this.handleNudgePropUpdate(this.data.dtree[0], chartData, state);
    const { meta } = this.data;
    const payload = {
      app_id: meta.app_id,
      jid: meta.jid,
      dtree: { statements: this.data.dtree }
    };
    this.datacontextService.journeys.upsertJourney(payload).subscribe((res: any) => {
      this.chartLoading = false;
      this.chartData.sendAnalyticsEvent = state;
      const message = meta.interactionMapName + ' Interaction Map is updated';
      this.commonNotificationService.showSnackBar(message, 'success', 2000);
    });
  }

  showAnalyticsAlertDialog(event, chartData) {
    if (chartData.sendAnalyticsEvent) {
      event.preventDefault();
      this.confirmationDialogRef = this.dialog.open(
        ConfirmationDialogComponent,
        {
          panelClass: 'generic-dialog-container-sm',
          disableClose: true,
          data: {
            title: 'Alert',
            body: 'Turning this off may impact your results as this Event will no longer be sent to your Analytics provider.'
          },
          autoFocus: false
        }
      );
      this.confirmationDialogRef.afterClosed().subscribe(result => {
        // since interaction map travarsal is bit heavy operation, we'll update the analytics event property only in case
        // if user has selected `Yes` option in the alert dialog. Below condtion will compare current value with user
        // selected value. Update only incase if both values are samw
        if (chartData.sendAnalyticsEvent === result) {
          chartData.sendAnalyticsEvent = !result;
          this.toggleAnalyticsEvent(!result, chartData);
        }
      });
    } else {
      this.toggleAnalyticsEvent(!chartData.sendAnalyticsEvent, chartData);
    }
  }

  clickRow(row) {
    this.expandedElement = this.expandedElement === row ? null : row;
    if (!this.expandedElement) {
      this.clearTimerAndSubs();
      this.resetTimeOptionsAndUpdateOpenedFlag();
    } else {
      this.resetTimeOptions(row);
      this.fetchAppDetailsAndQueryResult(row.lidx);
    }
  }

  getSelectedAppOs() {
    return this.appSelectorService.getSelectedApp().os;
  }

  generateRequestForReportDownload(promptElement) {
    this.feedbackReportRequested[promptElement.lidx] = true;
    const { meta } = this.data;
    const payload = {
      "app_id": meta.app_id,
      "journey_id": meta.jid,
      "nudge_id": promptElement.lidx,
      "nudge_template": promptElement.template,
      "nudge_name": promptElement.title,
      "email_ids": [meta.userEmail],
      "duration": this.getConvertedMinutes(this.selectedTimeOption.duration),
    }
    this.datacontextService.analytics.requestDownloadReportOfFeedbackNudges(payload).subscribe((res: any) => {
      this.feedbackReportRequested[promptElement.lidx] = false;
      if (!res.is_error) {
        const message = `We will send the link for downloading the report to ${meta.userEmail}. Please check your inbox after some time.`;
        this.commonNotificationService.showSnackBar(message, 'success', 8000);
      }
    });
  }

  getConvertedMinutes(value) {
    const quantifier: any = this.editorCommonService.getQuantifierFromString(value)[0];
    const number: any = this.editorCommonService.getNumberFromString(value)[0];
    let minutes: number;
    switch (quantifier) {
      case 'D':
        minutes = number * 24 * 60;
        break;
      case 'M':
        minutes = number * 30 * 24 * 60;
        break;
    }
    return minutes;
  }

  isReportDownloadBtnDisabled(promptElement) {
    const { attr, tdata } = this.chartData;
    const attr_tc = attr && attr.hasOwnProperty('event_count') ? attr.event_count : 0;
    const attr_uc = attr && attr.hasOwnProperty('user_count') ? attr.user_count : 0;
    if (!this.isFeedbackNudge(promptElement.template)) {
      return !(this.chartData.c_d + this.chartData.c_uv + this.chartData.c_v + attr_tc + attr_uc > 0);
    }
    if (this.feedbackReportRequested[promptElement.lidx]) {
      return true;
    }
    switch (promptElement.template) {
      case 'nps_with_user_feedback':
        return !(tdata.detr_ccount + tdata.pass_ccount + tdata.prom_ccount + attr_tc + attr_uc > 0);
      case 'rating_with_user_feedback':
        return !(tdata.cumul_average_rating > 0);
      default:
        if (tdata.hasOwnProperty('submission_count') && tdata.submission_count + attr_tc + attr_uc > 0) {
          return false;
        }
        return !this.hasKeys(tdata['last5_reviews']);
    }
  }

  getTooltipMessageForReportStatus(promptObj) {
    if (this.isReportDownloadBtnDisabled(promptObj)) {
      return 'User feedback has not been received yet';
    }
  }

  isFeedbackNudge(template) {
    return this.feedbackNudgeMap.hasOwnProperty(template);
  }

  populateDataForNonFeedbackNudges(header, body, titleWithTemplate) {
    const { attr } = this.chartData;
    const attr_tc = attr && attr.hasOwnProperty('event_count') ? attr.event_count : 0;
    const attr_uc = attr && attr.hasOwnProperty('user_count') ? attr.user_count : 0;
    body.push(titleWithTemplate);
    body.push(this.chartData.hasOwnProperty('c_v') ? this.chartData.c_v : 0);
    body.push(this.chartData.hasOwnProperty('c_uv') ? this.chartData.c_uv : 0);
    body.push(this.chartData.hasOwnProperty('c_d') ? this.chartData.c_d : 0);
    if (this.selectedEvent) {
      body.push(this.selectedEvent.name);
      body.push(attr_uc);
      body.push(attr_tc);
    }

    if (Object.keys(this.chartData['tdata']).length) {
      if (this.analyticsType === 'Button') {
        if (this.hasButton('b1_ccount')) {
          header.push(this.getButtonLabel('b1_count', this.chartData['lidx']));
          body.push(this.chartData['tdata']['b1_ccount']);
        }
        if (this.hasButton('b2_ccount')) {
          header.push(this.getButtonLabel('b2_count', this.chartData['lidx']));
          body.push(this.chartData['tdata']['b2_ccount']);
        }
      }
    }
  }

  populateDataForFeedbackNudges(promptElement, header, body, titleWithTemplate) {
    const { attr } = this.chartData;
    const attr_tc = attr && attr.hasOwnProperty('event_count') ? attr.event_count : 0;
    const attr_uc = attr && attr.hasOwnProperty('user_count') ? attr.user_count : 0;
    body.push(titleWithTemplate);
    body.push(this.chartData.hasOwnProperty('c_v') ? this.chartData.c_v : 0);
    body.push(this.chartData.hasOwnProperty('c_uv') ? this.chartData.c_uv : 0);
    body.push(this.chartData.hasOwnProperty('c_d') ? this.chartData.c_d : 0);
    if (this.selectedEvent) {
      body.push(this.selectedEvent.name);
      body.push(attr_uc);
      body.push(attr_tc);
    }

    if (Object.keys(this.chartData['tdata']).length) {
      const tdata = this.chartData['tdata'];
      if (this.showTotalViewsSubmissions(promptElement['template']) && this.isKeyPresentInChartData(this.analyticsType)) {
        header.push('Total Submissions');
        body.push(tdata.submission_count);
      }

      if (this.analyticsType === 'Multi') {
        this.getKeys(tdata['count']).forEach(item => {
          header.push(item);
          const percentage = this.calculatePercentage(tdata['count'][item], this.sumOfMultiChoice(tdata));
          body.push(`${tdata['count'][item]} (${percentage}%)`);
        });
      }

      if (this.analyticsType === 'NPS' || this.analyticsType === 'NPS-with-user-feedback') {
        header.push('NPS Score');
        body.push(this.calculateNpsScore(tdata));
        ['prom_ccount', 'pass_ccount', 'detr_ccount'].forEach(item => {
          header.push(this.labelsMap[item]);
          const percentage = this.calculatePercentage(tdata[item], this.sumOfNps(tdata));
          body.push(`${tdata[item]} (${percentage}%)`);
        });
      }

      if (this.analyticsType === 'Rating' || this.analyticsType === 'Rating-with-user-feedback') {
        header.push('Average Rating');
        body.push(`${tdata['cumul_average_rating']} Out of ${tdata['star_count']}`);
        this.getStarCountArray(tdata).forEach(item => {
          header.push(this.labelsMap[item.text]);
          body.push(`${tdata['sdata'][item.text] || 0}%`);
        });
      }
    }
  }

  exportResultInCSVFormat(promptElement) {
    const header = cloneDeep(this.resultService.getReportDataHeaderForNudges());
    if (this.selectedEvent) {
      header.push('Goal', 'Attributed User Count', 'Attributed Total Goal Events');
    }
    const body = [];
    const time = this.analyticsChartService.getStartAndEndTime(this.step, this.duration);
    let fileName;
    if (this.chartData && this.chartData.lidx === promptElement.lidx) {
      const title = this.chartData.title || promptElement.title || 'Nudge';
      const titleWithTemplate = `${title} (${this.templateToNameMap[promptElement['template']]})`;
      fileName = `${titleWithTemplate} - ${moment(time.start).format(`DD MMM'YY`)}_${moment(time.end).format(`DD MMM'YY`)}.csv`;

      const { meta } = this.data;
      body.push(meta.interactionMapName);
      if (!this.isFeedbackNudge(promptElement.template)) {
        this.populateDataForNonFeedbackNudges(header, body, titleWithTemplate);
      } else {
        this.populateDataForFeedbackNudges(promptElement, header, body, titleWithTemplate);
      }
    }
    const rows = [header, body];
    this.resultService.exportToCsv(fileName, rows);
  }

  /**
   * This method check if value present in any of the event property
   */
  ifAnyPropValueExist(rules) {
    for (let i = 0, l = rules.length; i < l; i++) {
      if (rules[i].value || rules[i].value === 0 || rules[i].value === false) {
        return true;
      }
    }
    return false;
  }

  onEventChange() {
    if (this.expandedElement) {
      this.fetchAppDetailsAndQueryResult(this.expandedElement.lidx);
    }
  }

  fetchAppDetailsAndQueryResult(lidx) {
    this.chartLoading = true;
    this.queryAndAttributeDataObserver();
    // if goal is not added, no need to call app details
    if (this.selectedEvent) {
      if (!this.appDetails) {
        this.settingsService.getAppDetails(this.appSelectorService.getSelectedApp().id).subscribe((data: any) => {
          if (data.api_response && !data.isError) {
            this.appDetails = data.api_response;
            this.getQueryAndAttributeData(lidx);
          }
        });
      } else {
        this.getQueryAndAttributeData(lidx);
      }
    } else {
      this.getQueryAndAttributeData(lidx);
    }
  }

  getQueryAndAttributeData(lidx) {
    this.queryPromptsAnalytics(lidx);
    this.getAttributeData(lidx);
  }

  getAttributeData = (lidx) => {
    this.clearTimeoutVal('attrTimeoutRef');
    this.clearSubscription('attrQuerySubscriber');
    // if goal is not added, don't call nudge-attribution
    if (!this.selectedEvent) {
      this.resultAttributeData.next(false);
      this.resultAttributeData.complete();
      return;
    }

    const wrapperNodes = this.nudgesAndWrapperNodes.wrapperNodes;
    let nodeObj;
    wrapperNodes.forEach(node => {
      const body = this.nodeIndexService.getNodeBody(node);
      if (body.exp_stack.length) {
        body.exp_stack.forEach(nudge => {
          if (nudge.lidx === lidx) {
            nodeObj = node;
          }
        });
      }
    });
    const branch_id = this.nodeIndexService.getNodePath(this.data.dtree[0], nodeObj, '');
    const time = this.analyticsChartService.getStartAndEndTime(this.step, this.duration);
    const payload = {
      branch_id,
      nudge_id: lidx,
      src_id: this.appDetails.smt_src_id,
      client_id: this.appDetails.smt_client_id,
      client_region: this.appDetails.smt_client_region,
      st: time.start.format('DD/MM/YYYY'),
      et: time.end.format('DD/MM/YYYY'),
      goal: this.selectedEvent,
      jh: this.data.meta.journey_hash
    };
    this.attrQuerySubscriber = this.resultService.getAttrCount(payload).subscribe((data: any) => {
      if (data.is_error) {
        if (data.error_type === 'ERROR_RETRY_AFTER_10') {
          this.clearTimeoutVal('attrTimeoutRef');
          this.attrTimeoutRef = setTimeout(this.getAttributeData, 10 * 1000, lidx);
        }
        return;
      }
      this.resultAttributeData.next(data.api_response);
      this.resultAttributeData.complete();
    });
  }

  resultQueryObserver(): Observable<any> {
    return this.resultQueryData.asObservable().pipe(catchError(error => of(error)));
  }

  resultAttributeObserver(): Observable<any> {
    return this.resultAttributeData.asObservable().pipe(catchError(error => of(error)));
  }

  /**
   * we need to re-initialize both the obeserver after calling complete method.
   * complete method marks the obeservable as done.
   * forkJoin won't work without calling compelte method of observable.
   * For sub-sequent call of forkJoin, we need to re-initialize both the obeserver
   */
  resetAndInitializeQueryAndAttributeObervable() {
    this.clearSubscription('resultQueryData');
    this.clearSubscription('resultAttributeData');
    if (!this.resultQueryData && !this.resultAttributeData) {
      this.resultQueryData = new Subject<any>();
      this.resultAttributeData = new Subject<any>();
    }
  }

  queryAndAttributeDataObserver() {
    this.resetAndInitializeQueryAndAttributeObervable();
    forkJoin([
      this.resultQueryObserver(),
      this.resultAttributeObserver()
    ]).subscribe((data: any) => {
      if (data && data.length) {
        this.chartData = data[0];
        if (this.selectedEvent) {
          this.chartData.attr = data[1];
        }
        this.chartLoading = false;
        this.activate(this.chartData);
        if (this.lineChartOptions.hasOwnProperty('scales') && this.lineChartOptions.scales.hasOwnProperty('xAxes') && this.lineChartOptions.scales.xAxes[0].hasOwnProperty('scaleLabel') && this.lineChartOptions.scales.xAxes[0].scaleLabel.hasOwnProperty('labelString')) {
          this.lineChartOptions.scales.xAxes[0].scaleLabel.labelString = 'TIMELINE';
          if (this.chartData.hasOwnProperty('tz')) {
            this.lineChartOptions.scales.xAxes[0].scaleLabel.labelString = `TIMELINE(${this.chartData['tz']})`;
          }
        }
      }
    });
  }

  clearSubscription(variableName) {
    if (this[variableName]) {
      this[variableName].unsubscribe();
      this[variableName] = null;
    }
  }

  shouldShowSelectedEventTypeOrProp(event) {
    return event && event.criteria && event.criteria.rules && event.criteria.rules.length && this.ifAnyPropValueExist(event.criteria.rules);
  }
}
